import { AnyObjectSchema, object, string } from 'yup'

export interface CredentialsFormValues {
  username: string
  password?: string
}

const initialValues: CredentialsFormValues = {
  username: '',
  password: '',
}

export const useCredentialsFormValidators = (
  withoutPassword = false,
): {
  initialValues: CredentialsFormValues
  validationSchema: AnyObjectSchema
} => {
  const validationSchema = object({
    username: string().required(''),
    password: withoutPassword ? string() : string().required(''),
  })

  return {
    initialValues,
    validationSchema,
  }
}
